import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import * as React from 'react';
var Column = function (_React$Component) {
  _inherits(Column, _React$Component);
  function Column() {
    _classCallCheck(this, Column);
    return _possibleConstructorReturn(this, (Column.__proto__ || Object.getPrototypeOf(Column)).apply(this, arguments));
  }
  return Column;
}(React.Component);
export default Column;